export default "__VITE_ASSET__a6ba0aad__"